var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{attrs:{"id":"main"}}),_c('h2',{staticClass:"has-text-centered pt-4 has-text-weight-bold"},[_vm._v(_vm._s(_vm.$t('cockpit-de-prestacao-de-servico')))]),_c('p',{staticClass:"has-text-centered"},[_vm._v(_vm._s(_vm.$t('pagina-em-construcao')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }